<template>
    <div class="inlinetip">
      <span class="inlinetip__tip-icon" v-tooltip.left.bottom-start="{ content: tooltip }">
          <font-awesome-icon :icon="infoCircle" />
      </span>
      <!--
      <div :id="id" class="tooltip">
        <p class="tooltip__title">
          <span class="tooltip__title-icon">
            <font-awesome-icon :icon="infoCircle" />
          </span>
          <slot name="title"></slot>
        </p>
        <p>
          <slot name="desc"></slot>
        </p>
      </div>
      -->
    </div>
</template>

<script>
import FontAwesomeIcon from '@fortawesome/vue-fontawesome';
import faInfoCircle from '@fortawesome/fontawesome-free-solid/faInfoCircle';

export default {
  components: {
    FontAwesomeIcon
  },
  props: {
    title: {
      type: String
    },
    desc: {
      type: String
    }
  },
  data () {
    return {
      id: 'tip_' + this._uid
    };
  },
  computed: {
    infoCircle () {
      return faInfoCircle;
    },
    tooltip () {
      return '<div class="tooltip"><p class="tooltip__title"><span class="tooltip__title-icon">' + this.tooltipInfoIconSvg() + '</span>' + this.title + '</p><p>' + this.desc + '</p></div>';
    }
  },
  methods: {
    tooltipInfoIconSvg () {
      return '<svg data-v-2870eb3c="" aria-hidden="true" data-prefix="fas" data-icon="info-circle" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" class="svg-inline--fa fa-info-circle fa-w-16"><path data-v-2870eb3c="" fill="currentColor" d="M256 8C119.043 8 8 119.083 8 256c0 136.997 111.043 248 248 248s248-111.003 248-248C504 119.083 392.957 8 256 8zm0 110c23.196 0 42 18.804 42 42s-18.804 42-42 42-42-18.804-42-42 18.804-42 42-42zm56 254c0 6.627-5.373 12-12 12h-88c-6.627 0-12-5.373-12-12v-24c0-6.627 5.373-12 12-12h12v-64h-12c-6.627 0-12-5.373-12-12v-24c0-6.627 5.373-12 12-12h64c6.627 0 12 5.373 12 12v100h12c6.627 0 12 5.373 12 12v24z" class=""></path></svg>';
    }
  }
};
</script>

<style lang="scss" scoped>
@import "../../stylesheets/variables.scss";
.inlinetip {
  position: relative;
  display: inline-block;
  vertical-align: 0.06em;
  &__tip-icon {
    svg {
      width: 0.75rem;
      height: 0.75rem;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/explorer/InlineTip.vue